import { HttpClient } from '@angular/common/http';
import { AuthenticatedTileLayer } from '../../../../maps/authenticated-tile-layer';
import { Component, AfterViewInit, OnDestroy, inject, ViewChild, ElementRef } from '@angular/core';
import * as L from 'leaflet';
import { ActivatedRoute } from '@angular/router';
import { Apiv1Service } from '../../../../services/apiv1.service';
import { Observable, of, map, catchError } from 'rxjs';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';


@Component({
  selector: 'app-track',
  imports: [MatMenuModule, MatIconModule],
  templateUrl: './track.component.html',
  styleUrl: './track.component.scss',
})



export class TrackComponent implements AfterViewInit, OnDestroy {

  private http = inject(HttpClient);

  ngOnDestroy(): void {
    this.map?.remove();
  }

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild('markerMenux') markerMenu!: MatMenu;
  @ViewChild('markerMenuBetweenSegments') markerMenuBetweenSegments!: MatMenu;

  // @ViewChild('menuAnchor',  { static: false }) menuAnchor!: ElementRef;
  // @ViewChild('menuAnchor2', { static: false }) menuAnchor2!: ElementRef;
  @ViewChild('menuAnchor', { static: false, read: ElementRef })
  menuAnchor!: ElementRef<HTMLElement>;

  @ViewChild('menuAnchor2', { static: false, read: ElementRef })
  menuAnchor2!: ElementRef<HTMLElement>;

  menuPos = { x: 0, y: 0 };
  markerContext: any = null;

  route: ActivatedRoute = inject(ActivatedRoute);
  store: Apiv1Service = inject(Apiv1Service);
  
  path: string = "/gps_track/";

  private map!: L.Map;
  //private pathMarkers: L.Marker[] = [];
  currentId: any;

  //private gpsPath!: L.Polyline;
  private markers: L.Marker[] = []; // store draggable markers
  
  track: Track = {
    Id: 0
  };

  ngAfterViewInit(): void {
    this.currentId = this.route.snapshot.params['id'];
    console.log("TrackComponent::ngAfterViewInit(): var [this.currentId]: ["+this.currentId+"].");

    this.initMap();
    this.drawPath();


    // Important for dynamic components
    setTimeout(() => {
      this.map.invalidateSize();

      this.map.on('contextmenu', (e: L.LeafletMouseEvent) => {
        this.addPoint(e.latlng);
      });

      // this.map.on('zoomend', () => {
      //   const zoom = this.map.getZoom();

      //   this.markers.forEach(marker => {
      //     marker.setOpacity(zoom < 15 ? 0 : 1);
      //   });
      // });

      this.map.on('zoomend', () => {
        const zoom = this.map.getZoom();

        this.markers.forEach(marker => {
          if (zoom < 15) {
            // Hide marker
            this.map.removeLayer(marker);
          } else {
            // Show marker
            if (!this.map.hasLayer(marker)) {
              this.map.addLayer(marker);
            }
          }
        });
      });


    });
  }//--- ngAfterViewInit()



  private storeAddLocation(latlng: L.LatLng): void {

    var loc = {
      "Lat": latlng.lat,
      "Lon": latlng.lng,
      "Alt": latlng.alt,
      "Time": new Date().toISOString()
    };

    var localId = 0;

    this.store.addForPath(this.path+this.currentId+"/location", loc).subscribe({
        next: (v) => localId=this.parseLocation(v),
        error: (e) => console.error(e),
        complete: () => this.doAddPoint(latlng, localId),
      });;
  }//--- storeAddLocation(latlng: L.LatLng)


  private addPoint(latlng: L.LatLng): void {
    this.storeAddLocation(latlng);
  }


  private doAddPoint(latlng: L.LatLng, id: number): void {
  
    var idx = this.track.Segments!.length-1;

    this.track.Segments![idx].gpsCoordinates.push([latlng.lat, latlng.lng]);
    this.track.Segments![idx].matchingLocationIds.push(id);

    this.updatePolyline(idx);
    this.addEditableMarkers();
  }//--- doAddPoint(latlng: L.LatLng, id: number)


  private initMap(): void {
    // Center example from your link: 48.6163, 9.6172, zoom 11
    this.map = L.map('map', {
      center: [48.802696, 9.5222],
      zoom: 13
    });

    new AuthenticatedTileLayer(
      '/api/v1/tile/a/{z}/{x}/{y}.png',
      this.http,
      {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors'
    }).addTo(this.map);

  }//--- initMap()






  private parseLocation( data: any) :number {
    console.log("TrackComponent::parseLocation(): var [data]: ["+data+"].");
    var loc : Location = data;//JSON.parse(data);
    return loc.Id;
  }



  private storeData( data: any){
    console.log("TrackComponent::storeData(): var [data]: ["+data+"].");
    this.track = JSON.parse(data);
    console.log("TrackComponent::storeData(): var [JSON.stringify(this.track)]: ["+JSON.stringify(this.track)+"].");

    if(this.track.Segments)
    {
      var len = this.track.Segments.length;
      console.log("TrackComponent::storeData(): var [len]: ["+len+"].");
      
      //var ss = this.track.First;

      for ( var i =0; i < len;i++ ){
        var s = this.track.Segments!.at(i)!;
        //var s = ss!;

        s.gpsCoordinates      = new Array<L.LatLngExpression>();
        s.matchingLocationIds = new Array<number>();

        var edgesMap = new Map<number, Edge>();

        if (s?.Edges){
          var lenEdges = s?.Edges.length;
          for (var posEdge=0; posEdge < lenEdges; posEdge++){
            var e = s.Edges!.at(posEdge)!;

            edgesMap.set(e.Id, e );
          }
        }

        if (s.First){
          var e = edgesMap.get(s.First!.Id)!;
          
          var loc = e.Location!;
          var latlng: L.LatLng = new L.LatLng(loc.Lat!, loc.Lon!);
          
          s.gpsCoordinates.push(latlng);
          s.matchingLocationIds.push(loc.Id);

          while (e.Next){
            e = edgesMap.get(e.Next!)!;
            if (e.Location){
              loc = e.Location!;
              var latlng: L.LatLng = new L.LatLng(loc.Lat!, loc.Lon!);
              s.gpsCoordinates.push(latlng);
              s.matchingLocationIds.push(loc.Id);
            }
          }//--- while (e.Next)
        }// ---if (s.First)
      }//--- for ( var i =0; i < len;i++ )
    }//-- if(this.track.Segments)
  }//--- storeData( data: any)



  private drawPath(): void {

    var self = this;

    this.store.getOneForPath(this.path + this.currentId).subscribe({
      next: (v) => this.storeData(v),
      error: (e) => console.error(e),
      complete: () => this.doDrawPath(),
    });
  }//--- drawPath()


  removeAllPolylines() {
    this.map.eachLayer(layer => {
      if (layer instanceof L.Polyline) {
        this.map.removeLayer(layer);
      }
    });
  }


  private doDrawPath(): void {
    console.log("TrackComponent::doDrawPath(): Start");

    if (this.track.Segments)
    {
      this.removeAllPolylines();
      console.log("TrackComponent::doDrawPath(): Vat [this.track.Segments.length]: ["+this.track.Segments.length+"].");
      var bounds: L.LatLngBounds | undefined = undefined;

      if (this.track.Segments.length > 0){

        const tooltipTrack = 
        "Track Id:   ["+this.track.Id+"] <br> "+
        "Track Name: ["+this.track.Name+"] <br> "+
        "Track Desc: ["+this.track.Description+"]";

        var idx = this.track.Segments.length-1;
        for (idx =0; idx<this.track.Segments.length; idx++ ) {

          const currIdx = idx;

          if (this.track.Segments[currIdx].gpsCoordinates.length > 0){

            const tooltipSegment = tooltipTrack + " <br> "+
            "Segment Id:  ["+this.track.Segments[currIdx].Id+"] <br> "+
            "Segment Name:["+this.track.Segments[currIdx].Name+"]"
            this.track.Segments[currIdx].gpsPath = L.polyline(this.track.Segments[currIdx].gpsCoordinates, {
              color: getColor(currIdx, true), //'red',
              weight: 4,
              opacity: 0.6,
              smoothFactor: 1,
              noClip: true
            }).
            bindTooltip(tooltipSegment, {
              permanent: false,  // true = always visible, false = only on hover
              sticky: true       // tooltip follows the cursor
            }).
            addTo(this.map);
            
            // Optional: fit map bounds to the path

            var boundsLocal = this.track.Segments[currIdx].gpsPath!.getBounds();

            if ( bounds === undefined ) bounds = boundsLocal;
            else bounds.extend(boundsLocal);
            
          }//--- if (this.track.Segments[currIdx].gpsCoordinates.length > 0)
        }

        this.map.fitBounds(bounds!);

        this.addEditableMarkers();
        this.enableAddPoints();
      }//--- if (this.track.Segments.length > 0)
    }//--- if (this.track.Segments)

    console.log("TrackComponent::doDrawPath(): End");
}//--- doDrawPath()

  

onMenuClick(action: string, context: any) {
  console.log('action', action, 'on', context);
  // do your logic
}

private addEditableMarkers(): void {
  //if (this.map.getZoom() > 13)
  {
    this.doAddEditableMarkers();
  }
}


private doAddEditableMarkers(): void {
  
  this.markers.forEach(m => m.remove());  
  this.markers = [];

  var idx = this.track.Segments!.length-1;
  for (idx=0;idx<this.track.Segments!.length; idx++)
  {
    var lenC = this.track.Segments![idx].gpsCoordinates.length;
    const currIdx = idx;

    this.track.Segments![currIdx].gpsCoordinates.forEach((coord, index) => {

      var localIndex = 0;
      if(idx==0 || index>0){

        const currIndex = this.markers.length;
        const currAffect = index == (lenC-1) && (idx+1)< this.track.Segments!.length ;
        const currLenC = lenC;
        var locId = this.track.Segments![currIdx].matchingLocationIds[index];
        console.log("TrackComponent::addEditableMarkers(): Var [locId]: ["+locId+"].");

        const tooltip = 
        "Location Id  ["+locId+"] <br>"+
        "Location ["+coord.toString()+"]";
        const icon = L.divIcon({
          className: '',
          html: `<div class="track-point" >${idx + 1}/${index + 1}</div>`,
          iconSize: [20, 20],
          iconAnchor: [10, 10]
        });

        const marker = L.marker(coord, {
          icon,
          draggable: true
        }).
        bindTooltip(tooltip, {
          permanent: false,// true = always visible, false = only on hover
          direction: "right",   
          sticky: false       // tooltip follows the cursor
        }).addTo(this.map);

        //this.pathMarkers.push(marker);

        //-------------------------------
        
        // Update polyline when dragged
        marker.on('drag', (event: any) => {
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Start");

          const pos = event.target.getLatLng();
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [pos]: ["+pos+"].");
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [idx]: ["+idx+"].");
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [currIdx]: ["+currIdx+"].");
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [index]: ["+index+"].");
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [currIndex]: ["+currIndex+"].");
          
          localIndex = currIndex;
          for (var idx2=0;idx2<currIdx; idx2++)
          {
            localIndex -= (this.track.Segments![idx2].gpsCoordinates.length-1);
          }
          console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [localIndex]: ["+localIndex+"].");
          
          // var locId = this.track.Segments![currIdx].matchingLocationIds[localIndex];
          // console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [locId]: ["+locId+"].");

          var loc = { "Lon":  pos.lng, "Lat": pos.lat};
          
          // var locPath = this.path + this.currentId + "/location/"+locId;
          // console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [locPath]: ["+locPath+"].");

          // console.log("TrackComponent::addEditableMarkers()::onDrag(): Var [locPath]: ["+locPath+"]. complete")
          console.log("TrackComponent::addEditableMarkers()::onDrag():complete: Var [lenC]: ["+lenC+"].");
          console.log("TrackComponent::addEditableMarkers()::onDrag():complete: Var [currLenC]: ["+currLenC+"].");

          this.track.Segments![currIdx].gpsCoordinates[localIndex] = [pos.lat, pos.lng];


          if(localIndex == (currLenC-1) && (currIdx+1)< this.track.Segments!.length){
            this.track.Segments![currIdx+1].gpsCoordinates[0] = [pos.lat, pos.lng];
            this.updatePolyline(currIdx);
            this.updatePolyline( currIdx+1);
          }
          else
          {
            this.updatePolyline(currIdx);
          }          
          //       this.store.updateForPath(locPath, loc).subscribe({
          //   //next: (v) => this.storeData(v),
          //   error: (e) => console.error(e),
          //   complete: () => 
          //     {

          //       //if (index == 0)
                  

          //     },
          // });//--- this.store.updateForPath(locPath, loc).subscribe
        });//--- marker.on('drag', (event: any) => 

        marker.on('dragend', (event) => {
           console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Start");

          const pos = event.target.getLatLng();
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [pos]: ["+pos+"].");
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [idx]: ["+idx+"].");
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [currIdx]: ["+currIdx+"].");
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [index]: ["+index+"].");
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [currIndex]: ["+currIndex+"].");
          
          localIndex = currIndex;
          for (var idx2=0;idx2<currIdx; idx2++)
          {
            localIndex -= (this.track.Segments![idx2].gpsCoordinates.length-1);
          }
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [localIndex]: ["+localIndex+"].");
          
          var locId = this.track.Segments![currIdx].matchingLocationIds[localIndex];
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [locId]: ["+locId+"].");

          var loc = { "Lon":  pos.lng, "Lat": pos.lat};
          
          var locPath = this.path + this.currentId + "/location/"+locId;
          console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [locPath]: ["+locPath+"].");

          this.store.updateForPath(locPath, loc).subscribe({
            //next: (v) => this.storeData(v),
            error: (e) => console.error(e),
            complete: () => 
              {
                console.log("TrackComponent::addEditableMarkers()::onDragEnd(): Var [locPath]: ["+locPath+"]. complete")
                console.log("TrackComponent::addEditableMarkers()::onDragEnd():complete: Var [lenC]: ["+lenC+"].");
                console.log("TrackComponent::addEditableMarkers()::onDragEnd():complete: Var [currLenC]: ["+currLenC+"].");

                this.track.Segments![currIdx].gpsCoordinates[localIndex] = [pos.lat, pos.lng];


                if(localIndex == (currLenC-1) && (currIdx+1)< this.track.Segments!.length){
                  this.track.Segments![currIdx+1].gpsCoordinates[0] = [pos.lat, pos.lng];
                  this.updatePolyline(currIdx);
                  this.updatePolyline( currIdx+1);
                }
                else
                {
                  this.updatePolyline(currIdx);
                }
                //if (index == 0)
                  

              },
          });//--- this.store.updateForPath(locPath, loc).subscribe        });
      });//--- marker.on('dragend', (e) => 

           
        //---------------------------

        marker.on('contextmenu', (e) => {
          // e.originalEvent is the underlying MouseEvent
          L.DomEvent.stopPropagation(e);  
          const mouseEvent = e.originalEvent;
          // pass to Angular component (see below)
          //openContextMenu(mouseEvent);
          localIndex = currIndex;
          for (var idx2=0;idx2<currIdx; idx2++)
          {
            localIndex -= (this.track.Segments![idx2].gpsCoordinates.length-1);
          }
 
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [idx]: ["+idx+"].");
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [currIdx]: ["+currIdx+"].");
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [index]: ["+index+"].");
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [currIndex]: ["+currIndex+"].");
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [localIndex]: ["+localIndex+"].");
          const cLocalIndex = localIndex;
          const cCurrIdx = currIdx;

          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [cLocalIndex]: ["+cLocalIndex+"].");
          console.log("TrackComponent::addEditableMarkers()::onContextmenu(): Var [cCurrIdx]: ["+cCurrIdx+"].");

          this.openContextMenu(e.originalEvent, 
            { 
              //markerIndex: currIndex, 
              markerIndex: cLocalIndex, 
              segmentIndex: cCurrIdx, 
              affectNextSegment: currAffect
            });
        });//--- marker.on('contextmenu', (e) => 

        this.markers.push(marker);

      }//--- if(idx==0 || index>0)
    });//--- this.track.Segments![currIdx].gpsCoordinates.forEach((coord, index) => 
  }//--- for (idx=0;idx<this.track.Segments!.length; idx++)
}//--- addEditableMarkers()



onMenuAction(action: string) {
  var strMethod = "TrackComponent::onMenuAction(action: ["+action+"]): ";
  console.log(strMethod + 'Action:', action, 'Marker:', this.markerContext);
  var index = this.markerContext.markerIndex;
  var idx = this.markerContext.segmentIndex;
  var affectNextSegment = this.markerContext.affectNextSegment;

  console.log(strMethod + "Var [index]: ["+index+"].");
  console.log(strMethod + "Var [idx]: ["+idx+"].");
  console.log(strMethod + "Var [affectNextSegment]: ["+affectNextSegment+"].");

  this.track.Segments![idx].gpsCoordinates.splice(index, 1); // remove from array
  var locId = this.track.Segments![idx].matchingLocationIds[index];
  this.track.Segments![idx].matchingLocationIds.splice(index, 1);

  if (action === 'delete'){
    var locPath = this.path + this.currentId + "/location/"+locId;
    console.log(strMethod + "Var [locPath]: ["+locPath+"].");

    this.store.deleteForPath(locPath).subscribe({
      //next: (v) => this.storeData(v),
      error: (e) => console.error(e),
      complete: () => {
        console.log("TrackComponent::onMenuAction(delete): Var [locPath]: ["+locPath+"]. complete")
        
        this.markers[index].remove();
        this.updatePolyline(idx);
        this.addEditableMarkers(); // redraw markers
  
      },
    });
  }

  else if (action === 'cut'){
    ///api/v1/gps_track/{gps_track_id}/split_at/location/{gps_location_id}
    var locPath = this.path + this.currentId + "/split_at/location/"+locId;
    console.log(strMethod + "Var [locPath]: ["+locPath+"].");

    this.store.updateForPathString(locPath, {}).subscribe({
      next: (v) => this.storeData(v),
      error: (e) => console.error(e),
      complete: () => {
        console.log("TrackComponent::onMenuAction(cut): Var [locPath]: ["+locPath+"]. complete")
        
        this.doDrawPath();
      },
    });

  }

  else if (action === 'merge'){
    var locPath = this.path + this.currentId + "/merge_at/location/"+locId;
    console.log(strMethod + "Var [locPath]: ["+locPath+"].");

    this.store.updateForPathString(locPath, {}).subscribe({
      next: (v) => this.storeData(v),
      error: (e) => console.error(e),
      complete: () => {
        console.log("TrackComponent::onMenuAction(merge): Var [locPath]: ["+locPath+"]. complete")
        this.doDrawPath();
      },
    });

  }

}//--- onMenuAction(action: string) 


  openMarkerMenu(x: number, y: number) {
    const el = this.menuAnchor.nativeElement;

    el.style.left = `${x}px`;
    el.style.top = `${y}px`;

    this.menuTrigger.menu = this.markerMenu;      // ensure proper menu
    this.menuTrigger.openMenu();

    
  }

  openBetweenSegmentsMenu(x: number, y: number) {
    var strMethod = "TrackComponent::openBetweenSegmentsMenu(x: "+x+", y: "+y+"): ";
    console.log(strMethod + 'Start');

    const el = this.menuAnchor.nativeElement;

    el.style.left = `${x}px`;
    el.style.top = `${y}px`;

    this.menuTrigger.menu = this.markerMenuBetweenSegments;
    this.menuTrigger.openMenu();
  }

  openContextMenu(event: MouseEvent, context: any) {
    event.preventDefault();
    var strMethod = "TrackComponent::openContextMenu(): ";
    console.log(strMethod + 'context:', context);

    this.markerContext = context;
     this.menuPos = { x: event.clientX, y: event.clientY };
      console.log(strMethod + 'this.menuPos:', this.menuPos);
    // // Move the hidden anchor
    // var  ancho : any;

    if (context.affectNextSegment){
      this.openBetweenSegmentsMenu(this.menuPos.x, this.menuPos.y);
      // ancho  = this.menuAnchor2.nativeElement;
    } else {
      this.openMarkerMenu(this.menuPos.x, this.menuPos.y);
      // ancho  = this.menuAnchor.nativeElement;
    }

    // ancho.style.left = this.menuPos.x + 'px';
    // ancho.style.top = this.menuPos.y + 'px';

    // setTimeout(() => {
    //   this.menuTrigger.openMenu();
    // });
  }//--- openContextMenu(event: MouseEvent, context: any)



private enableAddPoints(): void {

  var idx = this.track.Segments!.length-1;
  for (idx=0;idx<this.track.Segments!.length; idx++)
  {
    const currIdx = idx;

    console.log("TrackComponent::enableAddPoints()::onClick(): Var [idx]: ["+idx+"].");
    console.log("TrackComponent::enableAddPoints()::onClick(): Var [currIdx]: ["+currIdx+"].");


    this.track!.Segments![currIdx].gpsPath!.on('click', (event: L.LeafletMouseEvent) => {
      const latlng = event.latlng;

      // Find closest segment to insert point
      let  [newIdx, insertIndex] = this.findClosestSegmentIndex(latlng, currIdx);

      console.log("TrackComponent::enableAddPoints()::onClick(): Var [newIdx]: ["+newIdx+"].");
      console.log("TrackComponent::enableAddPoints()::onClick(): Var [insertIndex]: ["+insertIndex+"].");

      //this.gpsCoordinates.splice(insertIndex + 1, 0, [latlng.lat, latlng.lng]);
      this.track.Segments![newIdx].gpsCoordinates.splice(insertIndex + 1, 0, [latlng.lat, latlng.lng]);

      var locId = this.track.Segments![newIdx].matchingLocationIds[insertIndex];
      
      console.log("TrackComponent::enableAddPoints()::onClick(): Var [locId]: ["+locId+"].");

      var locPath = this.path + this.currentId + "/location/after/"+locId;
      console.log("TrackComponent::enableAddPoints()::onClick(): Var [locPath]: ["+locPath+"].");
      
      var loc = {
      "Lat": latlng.lat,
      "Lon": latlng.lng,
      "Alt": latlng.alt,
      "Time": new Date().toISOString()
    };
      var localId: number;
      this.store.addForPath(locPath, loc).subscribe({
        next: (v) => localId=this.parseLocation(v),
        error: (e) => console.error(e),
        complete: () => {
          console.log("TrackComponent::enableAddPoints()::onClick(): Var [locPath]: ["+locPath+"]. complete")
        this.track.Segments![newIdx].matchingLocationIds.splice(insertIndex + 1, 0, localId);
          // redraw markers
        this.updatePolyline(newIdx);
        
        this.addEditableMarkers();

        },
      });

      //this.drawPath();
    });

  }
}//--- enableAddPoints()



// Helper: find closest segment index to clicked location
private findClosestSegmentIndex(latlng: L.LatLng, idx: number): [number, number] {
  let minDistance = Infinity;
  let closestIndex = 0;


  var gpsCoordinates: L.LatLngExpression[] = [...this.track.Segments![idx].gpsCoordinates];
  if (idx > 0)
  {
    var len = this.track.Segments![idx-1].gpsCoordinates.length;
    var l  = this.track.Segments![idx-1].gpsCoordinates[len-1];
    gpsCoordinates.unshift(l);
    
  }

  for (let i = 0; i < gpsCoordinates.length - 1; i++) {
      const a = L.latLng(gpsCoordinates[i]);
      const b = L.latLng(gpsCoordinates[i + 1]);
      
      const distance = L.LineUtil.pointToSegmentDistance(
        this.map.latLngToLayerPoint(latlng),
        this.map.latLngToLayerPoint(a),
        this.map.latLngToLayerPoint(b)
      );
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = i;
      }
    }

    if ( idx > 0 ) {
      if ( 0 == closestIndex ){
        var len = this.track.Segments![idx-1].gpsCoordinates.length;
        closestIndex = len -1;
        idx = idx-1;
      }
      else{
        closestIndex = closestIndex-1;
      }
    }


    return [ idx, closestIndex ];
  }//--- findClosestSegmentIndex(latlng: L.LatLng)


  private updatePolyline(idx:number): void {
    //var idx = this.track.Segments!.length-1;
    if (undefined === this.track.Segments![idx].gpsPath)
    {
      this.doDrawPath();
    }
    else
    {
      //this.gpsPath.setLatLngs(this.gpsCoordinates);

      //for (var idx=0; idx<this.track.Segments!.length; idx++){
        this.track.Segments![idx].gpsPath!.setLatLngs(this.track.Segments![idx].gpsCoordinates);
      //}
    }
  }//--- updatePolyline(idx:number)

}


interface Location {

  Id             : number ;
	IdUserCreation? : number | null;
	TimeCreation?   : string | null;
	IdUserDeletion? : number | null;
	TimeDeletion?   : string | null;

  Time?          : string | null;
	Lat?           : number | null;
	Lon?           : number | null;
	Alt?           : number | null;
	SpeedMPS?      : number | null;
	AccuracyDiaM?  : number | null;
}

interface Edge {

  Id              : number ;
	IdUserCreation? : number | null;
	TimeCreation?   : string | null;
	IdUserDeletion? : number | null;
	TimeDeletion?   : string | null;

	TrackSegmentId ? : number   ;
	LocationId         ? : number   | null;
	Location           ? : Location | null;
	Previous       ? : number   | null;
	Next           ? : number   | null;

}

interface Segment {
  Id              : number;
	IdUserCreation? : number | null;
	TimeCreation?   : string | null;
	IdUserDeletion? : number | null;
	TimeDeletion?   : string | null;
	Name?           : string | null;
	Description?    : string | null;

	TrackId?        : number ;
	FirstId?        : number | null;
	First?          : Edge | null;
	LastId?         : number | null;
	Last?           : Edge | null;
	Edges?          : Array<Edge> | null;

  gpsCoordinates: L.LatLngExpression[];
  matchingLocationIds: number[];
  gpsPath?: L.Polyline;
}




interface Track {
  Id              : number ;
	IdUserCreation? : number | null;
	TimeCreation?   : string | null;
	IdUserDeletion? : number | null;
	TimeDeletion?   : string | null;
	Name?           : string | null;
	Description?    : string | null;

	FirstId?         : number | null;
	First?           : Segment | null;
	LastId?          : number | null;
	Last?            : Segment | null;
  Segments?        : Array<Segment> | null;
  OwnerUserId?     : number | null;
	FriendGroupId?   : number | null;
	MaxSpeed?        : number | null;
	MovingDistance?  : number | null;
	MovingTime?      : number | null;
	StoppedDistance? : number | null;
	StoppedTime?     : number | null;
}

function getColor(index: number, dark: boolean): string {
  // distribute hues around the color wheel
  const hue = (index * 137.508) % 360; 
  // 137.508° = golden angle → maximizes contrast

  // Base saturation & lightness
  let saturation = 70;
  let lightness = 55;

  // Adjust for darker or lighter variants
  if (dark) {
    lightness -= 20; // darker shade
  } else {
    lightness += 15; // lighter shade
  }

  // Keep values within range
  lightness = Math.max(0, Math.min(100, lightness));

  // Convert HSL → HEX
  return hslToHex(hue, saturation, lightness);
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;

  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);

  const f = (n: number) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

  const r = Math.round(255 * f(0));
  const g = Math.round(255 * f(8));
  const b = Math.round(255 * f(4));

  return "#" + [r, g, b].map(x => x.toString(16).padStart(2, "0")).join("");
}
